import { RoleAppNav } from '@/models/user-data.model';
import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { AppNav, NavCategory } from 'src/app/models/app-nav';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NavItemService {
  private BASE_URL = environment.landmark_API_URL + '/perms';
  navItems= signal<AppNav[]>([]);
isLargeScreen = false;
navCats= signal<NavCategory[]>([]);
navDialog = signal<boolean>(false);
clonedNavs= signal<{ [s: string]: AppNav }>({});

  constructor(private http: HttpClient) {
    this.populateNavItems();
   }

//===============app nav===================

  addNav(newNav: any): Observable<AppNav[]> {
    return this.http.post<AppNav[]>(`${this.BASE_URL}/appnav/`, newNav);
  }

  getNavs(): Observable<AppNav[]> {
    return this.http.get<AppNav[]>(`${this.BASE_URL}/appnav/`);
  }

  updateNav(navId: number, changes: Partial<AppNav>): Observable<AppNav> {
    return this.http.put<AppNav>(`${this.BASE_URL}/appnav/${navId}`, changes);
  }

  deleteNav(navId: number) {
    return this.http.delete(`${this.BASE_URL}/appnav/${navId}`);
  }

//===============app nav categories===================

  getNavCategories(): Observable<NavCategory[]> {
    return this.http.get<NavCategory[]>(`${this.BASE_URL}/navcats/`);
  }

  //===============Role Nav item===================

  addNavItem(appNavId: number, permRoleID:number): Observable<RoleAppNav> {
    const newRoleAppNav: Partial<RoleAppNav> = {
      appNavId: appNavId,
        PermRoleID: permRoleID,
    }
    return this.http.post<RoleAppNav>(`${this.BASE_URL}/roleappnav/`, newRoleAppNav);
  }

  deleteNavItem(appNavId: number) {
    return this.http.delete(`${this.BASE_URL}/roleappnav/${appNavId}`);
  }

    //===============signals===================
    getSelectedCategory(nav:AppNav) {
        if (this.navCats() && this.navCats().length > 0) {
          return this.navCats().find(cat => cat.navCategoryId === nav.appNavId) || null;
        }
        return null;
      }
    
      collectNavItems() {
        console.log('fetching nav items');
        this.getNavs().subscribe(data => {
          this.navItems.set(data);
          let navListIndex: { [appNavId: number]: AppNav } = {};
    
          this.navItems().forEach((nav: AppNav) => {
            navListIndex[nav.appNavId] = nav;
          });
          this.clonedNavs.set(navListIndex);
        });
      }

      populateNavItems() {
        this.getNavs().subscribe(data => {
          this.navItems.set(data);
        });
      }

}



